// JavaScript Document
$(function () {
/*
======================
BODY FADE IN
======================
*/

	setTimeout(function () {
		$("body").removeClass("fade-out");
	}, 320);

	setTimeout(function () {
		$("body").addClass("loaded");
		$("#page-loader").fadeOut(900);
		$(".page-wrap").removeClass("fade-out");
	}, 1200);

/*
===============================
ADDITIONAL BODYCLASSES
===============================
*/

	if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
		$("html").addClass("safari");
	}

	/*
================================
SCROLL ANIMATIONS (WOW JS)
================================
*/

	var wow = new WOW({
		boxClass: "wow",
		animateClass: "animated",
		offset: 0,
		mobile: true,
		live: true,
		scrollContainer: null,
		resetAnimation: false,
	});
	wow.init();

	/*
=========================
OBJECT FIT
=========================
*/

	$(function () {
		objectFitImages("img.object-fit");
	});

	/*
=====================
TEL LINKS
=====================
*/

	//Disable on desktop (non touch)...
	$(".no-touch a.tel").on("click", function (e) {
		e.preventDefault();
	});

	/*
=====================
TABLE WRAPPER
=====================
*/

	$("table").wrap('<div class="table-wrap"></div>');

	/*
======================
IFRAME WRAPPER
======================
*/

	$("section iframe").wrap('<div class="iframe-wrap"></div>');

	/*
===============================
FIXED HEADER
===============================
*/

	let lastScrollTop = 0;

	//add header class
	$(window).on("scroll", function () {
		let scrollTop = $(this).scrollTop();

		// Add "scrolled" class when not at the top
		if (scrollTop > 1) {
			$("#masthead").addClass("scrolled");
		} else {
			$("#masthead").removeClass("scrolled");
		}

		// Determine scroll direction
		if (scrollTop > lastScrollTop) {
			// Scrolling Down
			$("#masthead").removeClass("scrolling-up").addClass("scrolling-down");
		} else if (scrollTop < lastScrollTop) {
			// Scrolling Up
			$("#masthead").removeClass("scrolling-down").addClass("scrolling-up");
		}

		// Remove scrolling direction classes if at the very top
		if (scrollTop === 0) {
			$("#masthead").removeClass("scrolling-up scrolling-down");
		}

		lastScrollTop = scrollTop;
	});

	// On page load, check scroll position
	if ($(window).scrollTop() > 1) {
		$("#masthead").addClass("scrolled");
	}

	/*
======================
HAMBURGER MENU
======================
*/

	//open menu
	$(".menu-toggle").on("click", function () {
		$("body").toggleClass("mobile-navigation--open");
		$(this).toggleClass("active");
		$(".mobile-navigation").toggleClass("active");
	});

	$("#mobile-navigation .menu-item-has-children").append('<div class="menu-expand"><i class="fa-sharp fa-solid fa-chevron-down"></i></div>');

	$(".menu-expand").on("click", function () {
		$(this).toggleClass("active");
		$(this).parent("li").toggleClass("active");
		$(this).parent("li").toggleClass("sub-menu-open");
		$(this).parent("li").find("> ul.sub-menu").slideToggle(600);
	});

	//hover class
	$("#header-navigation ul li")
		.on("mouseenter", function () {
			$(this).addClass("active-hover");
		})
		.on("mouseleave", function () {
			$(this).removeClass("active-hover");
		});

	$(".main-menu .close").on("click", function () {
		$(".hamburger").removeClass("active");
		$(".main-menu").removeClass("active");
	});

	/*
================================
MENU AIM
================================
*/

	var $menu = $(".main-menu ul");

	$menu.menuAim({
		activate: activateSubmenu,
		deactivate: deactivateSubmenu,
	});

	function activateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.children("a").addClass("hover");
		$submenu.css({display: "block"});
	}

	function deactivateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.find("a").removeClass("hover");
		$submenu.css("display", "none");
	}

	$(document).click(function () {
		$(".main-menu ul li a.hover").removeClass("hover");
	});

	/*
=======================================
RESPONSIVE DATA TABLES
======================================
*/

	var tables = document.querySelectorAll(".page-section .table-wrap table");
	for (var a = 0; a < tables.length; a++) {
		var headertext = [];
		var headers = tables[a].querySelectorAll("thead td"),
			tablebody = tables[a].querySelector("tbody");

		for (var i = 0; i < headers.length; i++) {
			var current = headers[i];
			headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
		}
		for (var i = 0, row; (row = tablebody.rows[i]); i++) {
			for (var j = 0, col; (col = row.cells[j]); j++) {
				col.setAttribute("data-th", headertext[j]);
			}
		}
	}


	/*
=================================
FANCYBOX
=================================
*/


	$("[data-fancybox]").fancybox({
		autoFocus: false,
		touch: false,
		compact: false,
		beforeShow: function () {
			$("html").addClass("fancybox-opened");
			$("body").css("overflow", "hidden");
		},
		afterClose: function () {
			$("html").removeClass("fancybox-opened");
			$("body").css("overflow", "");
		},
	});

	// Prevent clicking from causing a scroll
	$("[data-fancybox]").on("click", function (e) {
		e.preventDefault();
	});


	/*
======================================
SMOOTH SCROLL
======================================
*/

	// SMOOTH SCROLLING FROM ANOTHER PAGE TO CORRECT ID
	//START AT TOP OF PAGE AND SCROLL DOWN ALWAYS
	/*if (window.location.hash) {
		setTimeout(function () {
			$("html, body").scrollTop(0).show();
			$("html, body").animate(
				{
					scrollTop: $(window.location.hash).offset().top - 0,
				},
				1000
			);
		}, 0);
	} else {
		$("html, body").show();
	}*/

	//SMOOTH SCROLLING
	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.not('[data-fancybox]')
		.click(function (event) {
			// On-page links
			if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$("html, body").animate(
						{
							scrollTop: target.offset().top - 0,
						},
						1000,
						function () {
							// Callback after animation
							// Must change focus!
						}
					);
				}
			}
		});

	/*
=========================
ACCORDION
=========================
*/

	/*
=========================
UP ARROW
=========================
*/

	$(".up").on("click", function (event) {
		event.preventDefault();
		$("body,html").animate({scrollTop: 0}, 1000);
	});

	/*
==========================
BUTTONS
==========================
*/

	if ($("p .button").length > 0) {
		$("p").each(function () {
			if ($(this).find(".button").length === 2) {
				$(this).addClass("two-buttons");
			}
		});
	}

	/*
==========================
SLIDERS
==========================
*/
(function ($) {
  function parseNumber(val, fallback) {
    const n = parseFloat(val);
    return Number.isFinite(n) ? n : fallback;
  }

  function parseIntSafe(val, fallback) {
    const n = parseInt(val, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function parseBool(val, fallback) {
    if (val === true || val === 1) return true;
    if (val === false || val === 0) return false;

    if (typeof val === "string") {
      const v = val.toLowerCase().trim();
      if (v === "1" || v === "true" || v === "yes") return true;
      if (v === "0" || v === "false" || v === "no") return false;
    }

    return fallback;
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function setWrapperGrid(wrapperEl, cols, gap, fixedWidth) {
    if (!wrapperEl) return;

    wrapperEl.style.display = "grid";
    wrapperEl.style.gap = `${gap}px`;
    wrapperEl.style.justifyContent = "start";
    wrapperEl.style.alignItems = "start";

    if (fixedWidth && fixedWidth > 0) {
      wrapperEl.style.gridTemplateColumns = `repeat(${cols}, ${fixedWidth}px)`;
      wrapperEl.style.justifyItems = "start";
    } else {
      wrapperEl.style.gridTemplateColumns = `repeat(${cols}, minmax(0, 1fr))`;
      wrapperEl.style.justifyItems = "";
    }
  }

  function clearWrapperGrid(wrapperEl) {
    if (!wrapperEl) return;
    wrapperEl.style.display = "";
    wrapperEl.style.gridTemplateColumns = "";
    wrapperEl.style.gap = "";
    wrapperEl.style.justifyContent = "";
    wrapperEl.style.alignItems = "";
    wrapperEl.style.justifyItems = "";
  }

  function resolveGridGap($wrap, fallbackGap) {
    const bp = parseIntSafe($wrap.data("grid-gap-breakpoint"), 1300);
    const gapLg = parseIntSafe($wrap.data("grid-gap-lg"), fallbackGap);
    const gapMd = parseIntSafe($wrap.data("grid-gap-md"), fallbackGap);

    return window.innerWidth > bp ? gapLg : gapMd;
  }

  function getSlideCount(wrapperEl) {
    return wrapperEl && wrapperEl.children ? wrapperEl.children.length : 0;
  }

  function getContainerWidth(swiperEl, wrap) {
    return (
      (swiperEl && swiperEl.clientWidth) ||
      (wrap && wrap.clientWidth) ||
      window.innerWidth ||
      0
    );
  }

  function getMinCardWidth($wrap) {
    return parseIntSafe($wrap.data("swiper-min-card-width"), 220);
  }

  function getGridFixedWidth($wrap) {
    return parseIntSafe($wrap.data("grid-fixed-width"), 0);
  }

  function getPeekFraction($wrap, fallbackPeek) {
    const fallbackFraction = fallbackPeek - Math.floor(fallbackPeek) || 0.15;
    return clamp(
      parseNumber($wrap.data("swiper-peek-fraction"), fallbackFraction),
      0.08,
      0.4
    );
  }

  function getBreakpoint($wrap) {
    return parseIntSafe($wrap.data("swiper-breakpoint"), 999999);
  }

  function getFirstSlideWidth(wrapperEl) {
    if (!wrapperEl || !wrapperEl.children || !wrapperEl.children.length) return 0;
    const firstSlide = wrapperEl.children[0];
    if (!firstSlide) return 0;

    const rect = firstSlide.getBoundingClientRect();
    return Math.round(rect.width || firstSlide.offsetWidth || 0);
  }

  function hasFixedWidthSlides($wrap, wrapperEl) {
    const gridFixedWidth = getGridFixedWidth($wrap);
    const firstSlideWidth = getFirstSlideWidth(wrapperEl);
    const minCardWidth = getMinCardWidth($wrap);

    if (gridFixedWidth > 0) return true;
    if (firstSlideWidth > 0 && Math.abs(firstSlideWidth - minCardWidth) <= 4) {
      return true;
    }

    return false;
  }

  function getFitStats($wrap, swiperEl, wrapperEl, gap, fallbackPeek) {
    const slideCount = getSlideCount(wrapperEl);
    const containerWidth = getContainerWidth(swiperEl, swiperEl?.parentElement);
    const minCardWidth = getMinCardWidth($wrap);
    const peekFraction = getPeekFraction($wrap, fallbackPeek);

    if (!slideCount || !containerWidth || !minCardWidth) {
      return {
        slideCount,
        containerWidth,
        minCardWidth,
        fullCards: 1,
        slidesPerView: fallbackPeek,
        allSlidesFit: slideCount <= 1,
      };
    }

    let fullCards = Math.floor((containerWidth + gap) / (minCardWidth + gap));
    fullCards = clamp(fullCards, 1, slideCount);

    let slidesPerView = fullCards;

    if (slideCount > fullCards) {
      slidesPerView = fullCards + peekFraction;
    }

    slidesPerView = Math.min(slideCount, slidesPerView);

    return {
      slideCount,
      containerWidth,
      minCardWidth,
      fullCards,
      slidesPerView,
      allSlidesFit: slideCount <= fullCards,
    };
  }

  function destroySwiper(wrap) {
    if (wrap._swiperInstance) {
      wrap._swiperInstance.destroy(true, true);
      wrap._swiperInstance = null;
    }
    wrap.classList.remove("is-swiper-active");
  }

  function shouldUseSwiper($wrap, fit) {
    const forceAlways =
      String($wrap.data("swiper-always")).toLowerCase() === "1" ||
      String($wrap.data("swiper-always")).toLowerCase() === "true";

    const breakpoint = getBreakpoint($wrap);

    if (forceAlways) return true;

    // Critical fix:
    // Never disable swiper just because the WINDOW is wider than the breakpoint.
    // The actual slider column may still be too narrow once the left content column
    // and container padding are taken into account.
    //
    // Use fit as the source of truth.
    if (!fit.allSlidesFit) return true;

    // Optional soft behaviour:
    // when everything fits, keep grid above breakpoint and also below breakpoint.
    // So if all slides fit, swiper is unnecessary.
    if (window.innerWidth > breakpoint) return false;

    return false;
  }

  function initSwipers() {
    $(".swiper-wrap").each(function () {
      const wrap = this;
      const $wrap = $(wrap);

      const swiperEl = $wrap.find(".swiper")[0];
      const wrapperEl = $wrap.find(".swiper-wrapper")[0];
      const paginationEl = $wrap.find(".swiper-pag")[0];
      const prevEl = $wrap.find(".swiper-button-prev")[0];
      const nextEl = $wrap.find(".swiper-button-next")[0];

      if (!swiperEl || !wrapperEl) return;

      const fallbackPeek = parseNumber($wrap.data("swiper-peek"), 1.15);
      const gap = parseIntSafe($wrap.data("swiper-gap"), 30);
      const centered = parseBool($wrap.data("swiper-centered"), false);
      const initialFromAttr = $wrap.data("swiper-initial-slide");
      const gridFixedWidth = getGridFixedWidth($wrap);
      const forceSingle = parseBool($wrap.data("swiper-force-single"), false);

      const fit = getFitStats($wrap, swiperEl, wrapperEl, gap, fallbackPeek);
      const slideCount = fit.slideCount;
      const enableSwiper = shouldUseSwiper($wrap, fit);

      if (enableSwiper) {
        clearWrapperGrid(wrapperEl);

        let initialSlide =
          initialFromAttr !== undefined &&
          initialFromAttr !== null &&
          initialFromAttr !== ""
            ? parseIntSafe(initialFromAttr, 0)
            : 0;

        if (slideCount <= 1) initialSlide = 0;
        initialSlide = clamp(initialSlide, 0, Math.max(0, slideCount - 1));

        const fixedWidthSlides = hasFixedWidthSlides($wrap, wrapperEl);

        const swiperConfig = {
          spaceBetween: gap,
          loop: false,
          autoplay: false,
          watchOverflow: true,
          centeredSlides: fixedWidthSlides ? false : centered,
          centeredSlidesBounds: false,
          centerInsufficientSlides: false,
          initialSlide: initialSlide,
          slidesPerGroup: 1,
          slidesPerGroupAuto: false,
          threshold: 8,
          observer: true,
          observeParents: true,
          resizeObserver: true,
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : undefined,
          navigation:
            prevEl && nextEl
              ? {
                  prevEl: prevEl,
                  nextEl: nextEl,
                }
              : undefined,
          freeMode: false,
          resistanceRatio: 0.85,
          watchSlidesProgress: true,
          roundLengths: true,
          longSwipesRatio: 0.2,
          shortSwipes: true,
          followFinger: true,
          grabCursor: true,
          slideToClickedSlide: false,
        };

        if (forceSingle) {
          swiperConfig.slidesPerView = 1;
        } else if (fixedWidthSlides || gridFixedWidth > 0) {
          swiperConfig.slidesPerView = "auto";
        } else {
          swiperConfig.slidesPerView = fit.slidesPerView;
        }

        if (!wrap._swiperInstance) {
          wrap._swiperInstance = new Swiper(swiperEl, swiperConfig);
          wrap.classList.add("is-swiper-active");
        } else {
          const currentIndex = clamp(
            wrap._swiperInstance.activeIndex || 0,
            0,
            Math.max(0, slideCount - 1)
          );

          wrap._swiperInstance.destroy(true, true);
          wrap._swiperInstance = new Swiper(swiperEl, swiperConfig);
          wrap.classList.add("is-swiper-active");
          wrap._swiperInstance.slideTo(currentIndex, 0, false);
        }

        if (paginationEl) {
          paginationEl.style.display = "";
        }

        if (prevEl) {
          prevEl.style.display = "";
        }

        if (nextEl) {
          nextEl.style.display = "";
        }
      } else {
        destroySwiper(wrap);

        const gridColsDefault = parseIntSafe($wrap.data("grid-cols"), 3);
        const gridGapResolved = resolveGridGap($wrap, gap);
        const gridCols = Math.min(
          Math.max(1, slideCount),
          Math.max(1, gridColsDefault)
        );

        setWrapperGrid(wrapperEl, gridCols, gridGapResolved, gridFixedWidth);

        if (paginationEl) {
          paginationEl.style.display = "none";
        }

        if (prevEl) {
          prevEl.style.display = "none";
        }

        if (nextEl) {
          nextEl.style.display = "none";
        }
      }
    });
  }

  let resizeTimer = null;

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initSwipers, 100);
  }

  $(function () {
    initSwipers();
    $(window).on("resize orientationchange", onResize);
  });
})(jQuery);





	// $(".swiper-wrap").each(function (index, element) {
	// 	var $this = $(element);

	// 	// Find elements inside this swiper-wrap only
	// 	var swiperEl     = $this.find(".swiper")[0];
	// 	var nextBtn      = $this.find(".swiper-button-next")[0];
	// 	var prevBtn      = $this.find(".swiper-button-prev")[0];
	// 	var paginationEl = $this.find(".swiper-pag")[0];

	// 	// Create a new swiper tied to this wrapper
	// 	new Swiper(swiperEl, {
	// 		slidesPerView: 1,
	// 		autoplay: false,
	// 		loop: false,
	// 		spaceBetween: 30,
	// 		navigation: {
	// 			nextEl: nextBtn,
	// 			prevEl: prevBtn,
	// 		},
	// 		pagination: {
	// 			el: paginationEl,
	// 			clickable: true,
	// 		},
	// 		breakpoints: {
	// 			768: {
	// 				slidesPerView: 2,
	// 				spaceBetween: 30,
	// 			},
	// 			1024: {
	// 				slidesPerView: 3,
	// 				spaceBetween: 30,
	// 			},
	// 			1200: {
	// 				slidesPerView: 3,
	// 				spaceBetween: 30,
	// 			},
	// 		},
	// 	});
	// });

	// //Small Image slider
	// var swiper2 = new Swiper(".swiper-6-slides .swiper", {
	// 	slidesPerView: 3,
	// 	spaceBetween: 10,
	// 	navigation: {
	// 		nextEl: ".swiper-6-slides .swiper-button-next",
	// 		prevEl: ".swiper-6-slides .swiper-button-prev",
	// 	},
	// 	pagination: {
	// 		el: ".swiper-6-slides .swiper-pag",
	// 		clickable: true,
	// 	},
	// 	breakpoints: {
	// 		900: {
	// 			slidesPerView: 4,
	// 			spaceBetween: 50,
	// 		},
	// 		1200: {
	// 			slidesPerView: 5,
	// 			spaceBetween: 70,
	// 		},
	// 		1600: {
	// 			slidesPerView: 6,
	// 			spaceBetween: 100,
	// 		},
	// 	},
	// });

	//Large Slider - Full
	$(".swiper-full").each(function() {
        var $full = $(this);

        // Initialize Swiper on the child .swiper element
        new Swiper($full.find(".swiper")[0], {
            spaceBetween: 0,
            slidesPerView: 1,
            autoplay: false,
            loop: false,
            navigation: {
                nextEl: $full.find(".swiper-button-next")[0],
                prevEl: $full.find(".swiper-button-prev")[0],
            },
            pagination: {
                el: $full.find(".swiper-pag")[0],
                clickable: true,
            },
        });
    });

	//Banner Slider
	var swiper1 = new Swiper(".banner-slider .swiper", {
		autoplay: true,
		loop: true,
		effect: "fade",
		slidesPerView: 1,
		spaceBetween: 50,
		centeredSlides: true,
		centeredSlidesBounds: true,
		navigation: false,
	});


	//Large Image Slider
	/*var swiper3 = new Swiper(".mySwiper3", {
		spaceBetween: 20,
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: ".large-image-slider .swiper-button-next",
			prevEl: ".large-image-slider .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pag-2",
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
		},
	});

	//reviews carousel
	var swiper2 = new Swiper(".reviews-carousel", {
		slidesPerView: 1,
		spaceBetween: 50,
		centeredSlides: false,
		centeredSlidesBounds: false,
		loop: true,
		navigation: {
			nextEl: ".reviews-carousel .swiper-button-next",
			prevEl: ".reviews-carousel .swiper-button-prev",
		},
		pagination: {
			el: ".reviews-carousel .swiper-pagination",
		},
		breakpoints: {
			680: {
				slidesPerView: 1,
				spaceBetween: 40,
			},
			850: {
				slidesPerView: 2,
				spaceBetween: 80,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 80,
			},
		},
	});

	//Single Page Related Content
	var swiper5 = new Swiper(".related__swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		navigation: {
			nextEl: ".reviews .swiper-button-next",
			prevEl: ".reviews .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pag-4",
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1600: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
	});*/

	/*
===========================
MATCH HEIGHTS
===========================
*/

	$(function () {
		$(".news-block h3.block-title").matchHeight({property: "height"});
	});


	/*
==========================
RECAPTCHA FADEOUT
==========================
*/

	$(window).on("scroll", function () {
		var documentHeight = $(document).height();
		var windowHeight = $(window).height();
		var scrollPosition = $(window).scrollTop();

		if (documentHeight - (windowHeight + scrollPosition) < 100) {
			$(".grecaptcha-badge").addClass("fade");
		} else {
			$(".grecaptcha-badge").removeClass("fade");
		}
	});

	/*
==========================
AJAX
==========================
*/

	//LOAD MORE POSTS
	$(".news-posts .posts-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		var loaded = $("input.post-count").val();

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_posts",
				already_loaded: loaded,
			},
			beforeSend: function () {
				$(".news-posts .posts-container .load-more-posts").fadeTo(600, 0, function () {
					$(".news-posts .posts-container .load-more-posts").html('<div class="load"></div>');
				});
				$(".news-posts .posts-container .load-more-posts").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$(".news-posts .posts-container .load-more-posts")
					.delay(1000)
					.fadeOut(700, function () {
						$(".news-posts .posts-container .load-more-posts").remove();
						$(".news-posts .posts-container").append(data);
					});
			},
		});
	});
}); //end document.ready





//my code

//if menu items have children, add chevron
const menuItemsWithChildren = document.querySelectorAll('.level-0.menu-item-has-children > a > span');
if(menuItemsWithChildren.length > 0) {
	menuItemsWithChildren.forEach(item => {
		//add chevron font awesome
		item.innerHTML += '<i class="fa-light fa-chevron-down"></i>';
	});
}
const menuItemsWithChildren2 = document.querySelectorAll('.level-1.menu-item-has-children > a, .level-2.menu-item-has-children > a');
if(menuItemsWithChildren2.length > 0) {
	menuItemsWithChildren2.forEach(item => {
		//add chevron font awesome
		item.innerHTML += '<i class="fa-light fa-chevron-right"></i>';
	});
}

//if men u item has class .btn, add
const menuLink = document.querySelector('.main-menu .menu-item-object-domestic-tax > a > span');
if(menuLink){
	const icon = document.createElement('i');
	icon.className = 'fa-light fa-location-dot';
	menuLink.prepend(icon);
}
const menuLink2 = document.querySelector('.main-menu .menu-item-object-international-tax > a > span');
if(menuLink2){
	const icon = document.createElement('i');
	icon.className = 'fa-light fa-globe';
	menuLink2.prepend(icon);
}

//change height of header sub menu as sub menu level 1 and 2 are pos absolute 
// Match each top-level submenu panel height to the tallest visible content inside it
function setHeaderSubMenuHeights() {
	const topLevelSubMenus = document.querySelectorAll('.main-menu .level-0 > .sub-wrap');

	if (!topLevelSubMenus.length) return;

	topLevelSubMenus.forEach((subMenu) => {
		// Reset any old inline sizing first
		subMenu.style.height = '';
		subMenu.style.minHeight = '';

		const nestedSubMenus = subMenu.querySelectorAll(
			'.level-1 > .sub-wrap, .level-2 > .sub-wrap'
		);

		nestedSubMenus.forEach((nested) => {
			nested.style.height = '';
			nested.style.minHeight = '';
		});

		const subMenuStyles = window.getComputedStyle(subMenu);
		const paddingTop = parseFloat(subMenuStyles.paddingTop) || 0;
		const paddingBottom = parseFloat(subMenuStyles.paddingBottom) || 0;
		const panelChrome = paddingTop + paddingBottom;

		// Natural content height of the level-0 submenu column
		const ownContentHeight = Math.max(subMenu.scrollHeight - panelChrome, 0);

		// Find tallest nested submenu content height
		let tallestNestedHeight = 0;

		nestedSubMenus.forEach((nested) => {
			const nestedStyles = window.getComputedStyle(nested);
			const nestedPaddingTop = parseFloat(nestedStyles.paddingTop) || 0;
			const nestedPaddingBottom = parseFloat(nestedStyles.paddingBottom) || 0;
			const nestedChrome = nestedPaddingTop + nestedPaddingBottom;

			const nestedContentHeight = Math.max(nested.scrollHeight - nestedChrome, 0);

			if (nestedContentHeight > tallestNestedHeight) {
				tallestNestedHeight = nestedContentHeight;
			}
		});

		const tallestContent = Math.max(ownContentHeight, tallestNestedHeight);

		// Only set a minimum height on the parent panel
		// Do not force exact heights on nested panels
		subMenu.style.minHeight = `${Math.ceil(panelChrome + tallestContent)}px`;
	});
}

// Run on load
window.addEventListener('load', setHeaderSubMenuHeights);

// Run on resize
window.addEventListener('resize', setHeaderSubMenuHeights);

//add level-0 text onto sub menu as a sub heading
// Add level-0 text into submenu as a sub-heading
document.querySelectorAll('.main-menu .level-0').forEach(menuItem => {
	const link = menuItem.querySelector(':scope > a');
	const subWrap = menuItem.querySelector(':scope > .sub-wrap');

	// Bail if required elements do not exist
	if (!link || !subWrap) return;

	// Prevent duplicate headings
	if (subWrap.querySelector('.menu-sub-heading')) return;

	// Prefer textContent, fall back cleanly
	const headingText = link.textContent?.trim();
	if (!headingText) return;

	const subHeading = document.createElement('h2');
	subHeading.className = 'menu-sub-heading';
	subHeading.textContent = headingText;

	subWrap.prepend(subHeading);
});


//button style appending an arrow

const buttons = document.querySelectorAll('.button');
if(buttons.length > 0){
	buttons.forEach(button => {
		if(button.classList.contains('back')){
			button.innerHTML += '<i class="fa-solid fa-arrow-left"></i>';
		}else{
			button.innerHTML += '<i class="fa-solid fa-arrow-right"></i>';
		}
	});
}

//button group in banner
const bannerContent = document.querySelector('.image-banner .content-wrap');

if (bannerContent && !bannerContent.querySelector('.button-wrap')) {
  const buttons = bannerContent.querySelectorAll('.button');

  if (buttons.length > 1) {
    const firstButton = buttons[0];
    const firstP = firstButton.closest('p');

    if (firstP) {
      const wrapper = document.createElement('div');
      wrapper.className = 'button-wrap';

      // Insert wrapper where the first button paragraph was
      firstP.parentNode.insertBefore(wrapper, firstP);

      buttons.forEach(button => {
        const parentP = button.closest('p');
        wrapper.appendChild(button);
        if (parentP) parentP.remove();
      });

      // Remove immediately-following empty <p> tags
      let next = wrapper.nextElementSibling;
      while (
        next &&
        next.tagName === 'P' &&
        next.innerHTML.replace(/&nbsp;|\s/g, '') === ''
      ) {
        const toRemove = next;
        next = next.nextElementSibling;
        toRemove.remove();
      }
    }
  }
}



